import { render } from "./ComplianceSpokeNav.vue?vue&type=template&id=01b5a505&scoped=true"
import script from "./ComplianceSpokeNav.vue?vue&type=script&lang=js"
export * from "./ComplianceSpokeNav.vue?vue&type=script&lang=js"

import "./ComplianceSpokeNav.vue?vue&type=style&index=0&id=01b5a505&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b5a505"]])

export default __exports__